import { Injectable } from '@angular/core';
import { EntityState, EntityStore, ID, StoreConfig } from '@datorama/akita';
import { FilterParams, Product, ProductFilter, ProductPageResponse } from 'src/app/models';

export interface ProductState extends EntityState<Product> {
  searchTerm: string;
  searchFilters: FilterParams<ProductFilter>;
  searchResults: ID[];
  frontpageProducts: ID[][];
  suggestedProducts: ID[];
  hasMore: boolean;
  pagedResponse: ProductPageResponse;
  page: number;
  pageSize: number;
  searchPageSize: number;
  searchOpen: boolean;
  searchOverview: boolean;
}

export const initialProductState: ProductState = {
  searchTerm: '',
  searchFilters: undefined,
  searchResults: [],
  frontpageProducts: [],
  suggestedProducts: [],
  hasMore: false,
  pagedResponse: {
    total: 0,
    products: [],
  },
  page: 0,
  pageSize: 40,
  searchPageSize: 4,
  loading: false,
  searchOpen: false,
  searchOverview: false,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'products' })
export class ProductStore extends EntityStore<ProductState, Product> {
  constructor() {
    super(initialProductState);
  }

  resetSearch() {
    this.update({ searchResults: [], hasMore: true, page: initialProductState.page });
  }

  updatePage(page: { hasMore: boolean; page: number }) {
    this.update(page);
  }
}
